import { gql } from "@outschool/ui-apollo";
import { LeaderFragment } from "@outschool/ui-components-website";

export const featuredTutorsQuery = gql`
  query FeaturedTutors($activityFormat: ClassFormat) {
    featured {
      popularTeachers(activityFormat: $activityFormat) {
        ...LeaderFragment
      }
    }
  }
  ${LeaderFragment}
`;
